import { useState, useEffect } from 'react';

interface UseIsDeviceReturnType {
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
}

export const useIsDevice = (): UseIsDeviceReturnType => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isTablet, setIsTablet] = useState<boolean>(false);
  const [isDesktop, setIsDesktop] = useState<boolean>(false);

  useEffect(() => {
    const checkIsDesktop = (): boolean => {
      const isDesktopByWidth = window.innerWidth >= 1024;
      return isDesktopByWidth;
    };

    const checkIsMobile = (): boolean => {
      const isMobileByWidth = window.innerWidth < 768;
      return isMobileByWidth;
    };

    const checkIsTablet = (): boolean => {
      const isTabletByWidth =
        window.innerWidth >= 768 && window.innerWidth < 1024;
      return isTabletByWidth;
    };

    setIsDesktop(checkIsDesktop());
    setIsMobile(checkIsMobile());
    setIsTablet(checkIsTablet());

    const handleResize = () => {
      setIsDesktop(checkIsDesktop());
      setIsMobile(checkIsMobile());
      setIsTablet(checkIsTablet());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, isTablet, isDesktop };
};

export default useIsDevice;
